import { put, takeLatest, call, all } from 'redux-saga/effects';
import Api from 'guardian/reducers/Api';

const FETCH_DASHBOARD_STATS = 'guardian/dashboard/FETCH_DASHBOARD_STATS';
const FETCH_DASHBOARD_STATS_SUCCESS = 'guardian/dashboard/FETCH_DASHBOARD_STATS_SUCCESS';
const FETCH_DASHBOARD_STATS_FAILURE = 'guardian/dashboard/FETCH_DASHBOARD_STATS_FAILURE';

const FETCH_RECENT_SCANS = 'guardian/dashboard/FETCH_RECENT_SCANS';
const FETCH_RECENT_SCANS_SUCCESS = 'guardian/dashboard/FETCH_RECENT_SCANS_SUCCESS';
const FETCH_RECENT_SCANS_FAILURE = 'guardian/dashboard/FETCH_RECENT_SCANS_FAILURE';

const FETCH_TIMESERIES = 'guardian/dashboard/FETCH_TIMESERIES';
const FETCH_TIMESERIES_SUCCESS = 'guardian/dashboard/FETCH_TIMESERIES_SUCCESS';
const FETCH_TIMESERIES_FAILURE = 'guardian/dashboard/FETCH_TIMESERIES_FAILURE';

const FETCH_BREAKDOWNS = 'guardian/dashboard/FETCH_BREAKDOWNS';
const FETCH_BREAKDOWNS_SUCCESS = 'guardian/dashboard/FETCH_BREAKDOWNS_SUCCESS';
const FETCH_BREAKDOWNS_FAILURE = 'guardian/dashboard/FETCH_BREAKDOWNS_FAILURE';

const SET_PERIOD = 'guardian/dashboard/SET_PERIOD';

export const actions = {
  fetchDashboardStats: () => ({ type: FETCH_DASHBOARD_STATS }),
  fetchRecentScans: () => ({ type: FETCH_RECENT_SCANS }),
  fetchTimeseries: (days) => ({ type: FETCH_TIMESERIES, payload: days }),
  fetchBreakdowns: (days) => ({ type: FETCH_BREAKDOWNS, payload: days }),
  setPeriod: (days) => ({ type: SET_PERIOD, payload: days }),
};

const initialState = {
  stats: null,
  recentScans: [],
  timeseries: null,
  breakdowns: null,
  period: 7,
  loading: false,
  timeseriesLoading: false,
  breakdownsLoading: false,
  error: null,
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS:
    case FETCH_RECENT_SCANS:
      return { ...state, loading: true, error: null };
    case FETCH_TIMESERIES:
      return { ...state, timeseriesLoading: true, error: null };
    case FETCH_BREAKDOWNS:
      return { ...state, breakdownsLoading: true, error: null };
    case SET_PERIOD:
      return { ...state, period: action.payload };
    case FETCH_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case FETCH_RECENT_SCANS_SUCCESS:
      return { ...state, loading: false, recentScans: action.payload };
    case FETCH_TIMESERIES_SUCCESS:
      return { ...state, timeseriesLoading: false, timeseries: action.payload };
    case FETCH_BREAKDOWNS_SUCCESS:
      return { ...state, breakdownsLoading: false, breakdowns: action.payload };
    case FETCH_DASHBOARD_STATS_FAILURE:
    case FETCH_RECENT_SCANS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_TIMESERIES_FAILURE:
      return { ...state, timeseriesLoading: false, error: action.payload };
    case FETCH_BREAKDOWNS_FAILURE:
      return { ...state, breakdownsLoading: false, error: action.payload };
    default:
      return state;
  }
}

function* fetchDashboardStatsSaga() {
  try {
    const response = yield call(Api.fetchDashboardStats);
    yield put({ type: FETCH_DASHBOARD_STATS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({
      type: FETCH_DASHBOARD_STATS_SUCCESS,
      payload: { total_scans: 0, success_rate: 0, failed_scans: 0, pii_detections_24h: 0, prompt_injections_24h: 0 },
    });
  }
}

function* fetchRecentScansSaga() {
  try {
    const response = yield call(Api.fetchRecentScans);
    yield put({ type: FETCH_RECENT_SCANS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_RECENT_SCANS_SUCCESS, payload: [] });
  }
}

function* fetchTimeseriesSaga(action) {
  try {
    const response = yield call(Api.fetchDashboardTimeseries, action.payload || 7);
    yield put({ type: FETCH_TIMESERIES_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_TIMESERIES_FAILURE, payload: error.message });
  }
}

function* fetchBreakdownsSaga(action) {
  try {
    const response = yield call(Api.fetchDashboardBreakdowns, action.payload || 7);
    yield put({ type: FETCH_BREAKDOWNS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_BREAKDOWNS_FAILURE, payload: error.message });
  }
}

export function* dashboardSagas() {
  yield all([
    takeLatest(FETCH_DASHBOARD_STATS, fetchDashboardStatsSaga),
    takeLatest(FETCH_RECENT_SCANS, fetchRecentScansSaga),
    takeLatest(FETCH_TIMESERIES, fetchTimeseriesSaga),
    takeLatest(FETCH_BREAKDOWNS, fetchBreakdownsSaga),
  ]);
}
